﻿import { GeoJSON } from 'ol/format';

export default class FeatureHandler {
    constructor(generalSettingsHandler, layerSettingsHandler, rootURL, mapControl) {
        this.generalSettingsHandler = generalSettingsHandler;
        this.layerSettingsHandler = layerSettingsHandler;
        this.rootURL = rootURL;
        this.mapControl = mapControl;
    }

    requestFeature(layerId, featureId, ignore) {
        let layer = this.mapControl.layerHandler.getLayerById(layerId)[0];
        let featureUrl = layer.getSource().getUrl()([]);
        let layerConfig = this.layerSettingsHandler.getLayerSettings(layerId);
        if (layerConfig.Interpretation == 'NATIVE_XP') {
            return this.getNativeFeature(layerConfig, featureId, layerId, ignore);
        } else {
            return this.getWfsFeature(layerConfig, featureUrl, featureId, layerId, ignore);
        }
    }

    requestFeatures(layerId, featureIds) {
        let layer = this.mapControl.layerHandler.getLayerById(layerId)[0];
        let featureUrl = layer.getSource().getUrl()([]);
        let layerConfig = this.layerSettingsHandler.getLayerSettings(layerId);
        if (layerConfig.Interpretation == 'NATIVE_XP') {
            return [];
        } else {
            return this.getWfsFeatures(layerConfig, featureUrl, featureIds);
        }
    }

    getNativeFeature(layerConfig, featureId, layerUid, ignore) {
        let featureUrl = this.rootURL + 'Map/GetFeatureById?layer=' + layerConfig.Id + '&srs=' + this.mapControl.map.getView().getProjection().getCode();

        if (featureId != null && featureId != '') {
            featureUrl += '&pkVal=' + featureId;
        }

        var xmlHttp = new XMLHttpRequest();
        xmlHttp.open("GET", featureUrl, false);
        xmlHttp.send(null);
        var response = xmlHttp.responseText;

        if (response != null) {
            var features = new GeoJSON({ geometryName: layerConfig.Entity.GeometryFieldName }).readFeatures(JSON.parse(response));
            if (features != null && features.length == 1) {
                features[0].layerId = layerUid;
                return features[0];
            } else {
                if (!ignore) {
                    return null;
                }
                throw "ERR_FEATURE_NOT_FOUND";
            }
        } else {
            if (hasFilter) {
                if (!ignore) {
                    return null;
                }
                throw "ERR_LAYER_FILTER_APPLIED";
            } else {
                if (!ignore) {
                    return null;
                }
                throw "ERR_FEATURE_NOT_FOUND";
            }
        }
    }

    getWfsFeature(layerConfig, featureUrl, featureId, layerUid, ignore) {
        let hasFilter = false;
        if (layerConfig.Entity.PkFieldDataType == 'STRING') {
            featureId = "'" + featureId + "'";
        }

        if (featureUrl.indexOf('CQL_FILTER') >= 0) {
            hasFilter = true;
            featureUrl += ' and (' + layerConfig.Entity.PkFieldName + "==" + featureId + ')';
        } else {
            featureUrl += '&CQL_FILTER=(' + layerConfig.Entity.PkFieldName + "==" + featureId + ')';
        }

        var xmlHttp = new XMLHttpRequest();
        xmlHttp.open("GET", featureUrl, false);
        xmlHttp.send(null);
        var response = xmlHttp.responseText;

        var json = JSON.parse(response);

        if (JSON.parse(response).features != null && JSON.parse(response).features.length == 1) {
            var features = new GeoJSON({ geometryName: layerConfig.Entity.GeometryFieldName }).readFeatures(json);
            if (features != null && features.length == 1) {
                features[0].layerId = layerUid;
                return features[0];
            } else {
                if (!ignore) {
                    return null;
                }
                throw "ERR_FEATURE_NOT_FOUND";
            }
        } else {
            if (hasFilter) {
                if (!ignore) {
                    return null;
                }
                throw "ERR_LAYER_FILTER_APPLIED";
            } else {
                if (!ignore) {
                    return null;
                }
                throw "ERR_FEATURE_NOT_FOUND";
            }
        }
    }

    getWfsFeatures(layerConfig, featureUrl, featureIds) {
        let hasFilter = false;

        let featureId = '(';

        for (let i = 0; i < featureIds.length; i++) {
            if (layerConfig.Entity.PkFieldDataType == 'STRING') {
                featureId += "'" + featureIds[i] + "'";
            } else {
                featureId += featureIds[i];
            }

            if (i < featureIds.length - 1) {
                featureId += ',';
            }
        }

        featureId += ')';

        let idField = layerConfig.Entity.PkFieldName;

        if (idField == 'id') {
            idField = '"' + idField + '"';
        }

        if (featureUrl.indexOf('CQL_FILTER') >= 0) {
            hasFilter = true;
            featureUrl += ' and (' + idField + " in " + featureId + ')';
        } else {
            featureUrl += '&CQL_FILTER=(' + idField + " in " + featureId + ')';
        }

        var xmlHttp = new XMLHttpRequest();
        xmlHttp.open("GET", featureUrl, false);
        xmlHttp.send(null);
        var response = xmlHttp.responseText;

        var json = JSON.parse(response);

        if (JSON.parse(response).features != null && JSON.parse(response).features.length > 0) {
            var features = new GeoJSON({ geometryName: layerConfig.Entity.GeometryFieldName }).readFeatures(json);
            if (features != null && features.length > 0) {
                return features;
            } else {
                throw "ERR_FEATURE_NOT_FOUND";
            }
        } else {
            if (hasFilter) {
                throw "ERR_LAYER_FILTER_APPLIED";
            } else {
                throw "ERR_FEATURE_NOT_FOUND";
            }
        }
    }

    addFeature(feature, action) {

        if (feature.features.length == 0 || feature.features[0].geom == null) {
            return;
        }
        var ok = true;

        showLoadingPanel();
        $.ajax({
            type: "POST",
            url: this.rootURL + "MapFeature/AddFeature",
            contentType: "application/json; charset=utf-8",
            data: JSON.stringify({ "IdMapLayer": feature.layerId, "IdFeature": 0, "FeatureWkt": feature.features[0].geom }),
            async: false,
            success: (msg) => {
                hideLoadingPanel();
                if (action != null && action.SubType == 'ADD') {
                    let item = JSON.parse(msg.jsonEntity);

                    var _url = this.rootURL + 'EntityForm/EntityFormRuntime?context=modal&idForm=' + action.IdFormTarget + '&pkVal=';

                    _url += item.id;
                    _url += '&idApp=' + xapp.currentApp;
                    let modalTitle = action.Title;
                    let modalIcon = action.Icon;
                    let modalWidth = '75%';
                    let modalHeight = '75%';
                    if (action.UiContent != null && action.UiContent.trim() != '') {
                        let uiContent = JSON.parse(action.UiContent);

                        if (uiContent.modalWidth != null && uiContent.modalWidth.trim() != '') {
                            modalWidth = uiContent.modalWidth;
                        }

                        if (uiContent.modalHeight != null && uiContent.modalHeight.trim() != '') {
                            modalHeight = uiContent.modalHeight;
                        }
                    }

                    showModalWindow(_url, modalTitle, modalIcon, modalWidth, modalHeight);
                }
            },
            error: function () {
                hideLoadingPanel();
                ok = false;
            }
        });

        return ok;

    }

    updateFeature(feature) {

        if (feature.features.length == 0) {
            return;
        }
        var ok = true;

        let features = [];

        feature.features.forEach(feat => {
            features.push({ "IdMapLayer": feature.layerId, "IdFeature": feat.id, "FeatureWkt": feat.geom });
        });

        showLoadingPanel();
        $.ajax({
            type: "POST",
            url: this.rootURL + "MapFeature/UpdateFeature",
            contentType: "application/json; charset=utf-8",
            data: JSON.stringify(features),
            async: false,
            success: function (msg) {
                hideLoadingPanel();
            },
            error: function () {
                hideLoadingPanel();
                ok = false;
            }
        });

        return ok;
    }

    removeFeatures(features) {

        if (features == null || features.length == 0) {
            return;
        }
        var featuresToRemove = [];
        var layerIds = [];
        for (var i = 0; i < features.length; i++) {
            layerIds.push(features[i].layerId);
            featuresToRemove.push({ "IdMapLayer": features[i].layerId, "IdFeature": features[i].get(this.mapControl.getLayerSettings(features[i].layerId).Entity.PkFieldName)});
        }

        var ok = true;
        showLoadingPanel();
        $.ajax({
            type: "POST",
            url: this.rootURL + "MapFeature/RemoveFeatures",
            contentType: "application/json; charset=utf-8",
            data: JSON.stringify(featuresToRemove),
            async: false,
            success: (msg) => {

                for (var i = 0; i < layerIds.length; i++) {
                    this.mapControl.selectionHandler.deselectAll(layerIds[i]);
                    this.mapControl.refreshLayer(layerIds[i]);
                }
                hideLoadingPanel();
            },
            error: () => {
                hideLoadingPanel();
                ok = false;
            }
        }); $(this.mapControl.map.target).css({ "cursor": "crosshair" });

        return ok;
    }

    removeFeaturesGeometry(features) {

    }
}